import React from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  Youtube,
  Instagram,
  Facebook,
  Tiktok
} from "react-bootstrap-icons";
import wazeIcon from "../../assets/waze.svg";
import activeWazeIcon from "../../assets/active_waze.svg";
import { getFooterData } from "../../data/navbarFooter";
import "./footer.css";

const Footer = () => {
  const footerData = getFooterData();

  const iconMap = {
    Youtube,
    Instagram,
    Facebook,
    Tiktok
  };
  return (
    <>
      <footer className="main-footer text-white text-center">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              
              <div className="mb-4">
                <img
                  src={footerData.logo}
                  alt="Logo"
                  className="footer-logo"
                />
              </div>

              <p className="footer-description">
                {footerData.description}
              </p>

              <Nav className="justify-content-center footer-nav">
                {footerData.navLinks.map((link) => (
                  <Nav.Link key={link.path} as={Link} to={link.path}>
                    {link.label}
                  </Nav.Link>
                ))}
              </Nav>

              <div className="social-icons mt-4 d-flex justify-content-center gap-4">
                {footerData.socialLinks.map((social) => {
                  const IconComponent = iconMap[social.icon];
                  return (
                    <Link
                      key={social.name}
                      to={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Visit our ${social.name} page`}
                    >
                      {social.icon === "Waze" ? (
                        <div className="waze-icon-wrapper">
                          <img 
                            src={wazeIcon} 
                            alt="Waze" 
                            className="waze-icon-default"
                          />
                          <img 
                            src={activeWazeIcon} 
                            alt="Waze" 
                            className="waze-icon-hover"
                          />
                        </div>
                      ) : (
                        <IconComponent size={20} />
                      )}
                    </Link>
                  );
                })}
              </div>

            </Col>
          </Row>
        </Container>
      </footer>

      <div className="footer-bottom">
        <Container fluid className="col-11 mx-auto">
          <Row className="align-items-center">
            <Col md={6} className="text-center text-md-start">
              {footerData.copyright.text}
              {/* <span className="ms-2">
                <Link
                  to={footerData.copyright.developer.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {footerData.copyright.developer.text}
                </Link>
              </span> */}
            </Col>

            <Col md={6} className="text-center text-md-end">
              {footerData.legalLinks.map((link, index) => (
                <React.Fragment key={link.path}>
                  <Link to={link.path} aria-label={link.label}>
                    {link.label}
                  </Link>
                  {index < footerData.legalLinks.length - 1 && " | "}
                </React.Fragment>
              ))}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Footer;